import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminProtectedRoute from './AdminProtectedRoute';
import AdminLayout from './AdminLayout';
import AdminDashboard from './AdminDashboard';
import Retailers from './pages/retailers';
import BusinessPackages from '../manage/businessPackages';
import BusinessTypes from '../manage/businessType';
import Currencies from '../components/pages/currencies';


const AdminRoutes = () => {
  return (
    <Routes>
      {/* All admin routes wrapped in layout and protection */}
      <Route element={<AdminProtectedRoute><AdminLayout /></AdminProtectedRoute>}>
        <Route path="/dashboard" element={<AdminDashboard />} />
        <Route path="/retailers" element={<Retailers />} />
        <Route path="/manage/packages" element={<BusinessPackages />} />
        <Route path="/manage/business-types" element={<BusinessTypes />} />
        <Route path="/manage/currency" element={<Currencies />} />


        {/* Add other protected admin routes here */}
      </Route>
    </Routes>
  );
};

export default AdminRoutes;